import { useContext, useState, useEffect } from 'react';

import { GlobalContext } from "../../contexts/globalContext";

import CornerImage from "../../graphics/config/colt.png"
import DeskHImage from "../../graphics/config/masa-h.png"
import DeskVImage from "../../graphics/config/masa-v.png"
import separator from "../../graphics/config/picior.png"


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import styles from './StationMapComponent.module.css';
import DarkButtonComponent from '../commons/DarkButtonComponent';

import Lottie from 'react-lottie-player';
import startAnimation from '../../graphics/conferenceScreen/power-on-anim.json'

const StationMapComponent = ({ setOpenStationsMap, onlineDevices, deviceToStart, desksIdsForAnim, setDesksIdsForAnim, onDeskClicked }) => {

    const { deskData, socketRef } = useContext(GlobalContext);

    const [room, setRoom] = useState();
    const [deskHeight, setDeskHeight] = useState(100);
    const [devicesToStart, setDevicesToStart] = useState([]);

    const separatorRatio = 0.07 // width / height

    useEffect(() => {
        socketRef.current.emit('GET_ROOM_BY_ID', deskData.room._id, room => {

            let currentParticipantSide = null;

            const deskLocations = {
                0: room.desks_north,
                1: room.desks_east,
                2: room.desks_south,
                3: room.desks_west
            };

            for (const [side, desks] of Object.entries(deskLocations)) {
                if (desks?.find(desk => desk._id === deskData._id)) {
                    currentParticipantSide = parseInt(side);
                    break;
                }
            }

            if (currentParticipantSide !== 2) {

                let new_desks_south = deskLocations[currentParticipantSide]
                let new_desks_west = deskLocations[(currentParticipantSide + 1) % 4]
                let new_desks_north = deskLocations[(currentParticipantSide + 2) % 4]
                let new_desks_east = deskLocations[(currentParticipantSide + 3) % 4]

                if (currentParticipantSide === 0) {
                    new_desks_south = new_desks_south?.slice().reverse()
                    new_desks_west = new_desks_west?.slice().reverse()
                    new_desks_north = new_desks_north?.slice().reverse()
                    new_desks_east = new_desks_east?.slice().reverse()
                } else if (currentParticipantSide === 1) {
                    new_desks_south = new_desks_south?.slice().reverse()
                    new_desks_north = new_desks_north?.slice().reverse()
                } else {
                    new_desks_west = new_desks_west?.slice().reverse()
                    new_desks_east = new_desks_east?.slice().reverse()
                }


                room.desks_south = new_desks_south
                room.desks_west = new_desks_west
                room.desks_north = new_desks_north
                room.desks_east = new_desks_east
            }

            setRoom(room)

            var newDskHeight = 70;
            var mxx = Math.max(room.desks_east?.length, room.desks_west.length);

            if (mxx > 0) {
                var discac = Math.trunc(1100 / (mxx + 1.5));

                if (discac > 0) {
                    newDskHeight = discac;
                }
            }
            setDeskHeight(newDskHeight);

        })

    }, [])

    useEffect(() => {
        if (deviceToStart) {
            setDevicesToStart([...devicesToStart, deviceToStart]);
        }
    }, [deviceToStart])


    return (
        <div className={styles.component} >
            <div className={styles.header}>
                <div className={styles.location}>{room?.location.name}</div>
                {room?.name}
            </div>
            <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    {
                        room?.desks_north.length > 0 && room?.desks_west.length > 0 && <>
                            <img src={CornerImage} height={deskHeight} />
                            <img alt={"img"} src={separator} height={deskHeight} />
                        </>
                    }
                    {room?.desks_north.map((desk) => {
                        let deskState = onlineDevices.find(
                            (deviceId) => deviceId === desk.deviceId
                        );

                        return (<div key={desk.number} style={{ position: "relative", display: "flex", justifyContent: "center" }} onClick={() => {
                            onDeskClicked(desk.deviceId, deskState)
                            if (!deskState) {
                                if (!desksIdsForAnim.find(id => id === desk._id))
                                    setDesksIdsForAnim((desksId) => [...desksId, desk._id])
                            } else {
                                let filteredDesksIds = desksIdsForAnim.filter(id => id !== desk._id)
                                setDesksIdsForAnim(filteredDesksIds)
                            }
                        }}>
                            <img src={DeskHImage} height={deskHeight} />
                            <img alt={"img"} src={separator} height={deskHeight} />
                            <span style={{ position: "absolute", fontSize: deskHeight / 5, bottom: deskHeight / 1.5, pointerEvents: "none" }}>
                                {deskState &&
                                    <FontAwesomeIcon style={{ color: "#33FFC8" }} icon={byPrefixAndName.fas['power-off']} />
                                }
                                {!deskState && !desksIdsForAnim.find(id => id === desk._id) &&
                                    <FontAwesomeIcon style={{ color: "#000000" }}
                                        icon={byPrefixAndName.fas['power-off']} />
                                }
                                {!deskState && desksIdsForAnim.find(id => id === desk._id) && <Lottie
                                    loop={true}
                                    play={true}
                                    animationData={startAnimation}
                                    style={{ width: deskHeight / 3, height: deskHeight / 3, top: 0, position: "relative" }}
                                />}
                            </span>
                            {devicesToStart.includes(desk.deviceId) && <span className={styles.loader} style={{ position: 'absolute', fontSize: 70, bottom: 30, color: "white" }}></span>}

                        </div>
                        )
                    })}
                    {
                        room?.desks_north.length > 0 && room?.desks_east.length > 0 && <img src={CornerImage} height={deskHeight} style={{ transform: "rotate(90deg)" }} />
                    }
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%", display: "flex", justifyContent: "start" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {room?.desks_west.map((desk, index) => {
                                let deskState = onlineDevices.find(
                                    (deviceId) => deviceId === desk.deviceId
                                );

                                return (<div key={desk.number} style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "center" }} onClick={() => {
                                    onDeskClicked(desk.deviceId, deskState)
                                    if (!deskState) {
                                        if (!desksIdsForAnim.find(id => id === desk._id))
                                            setDesksIdsForAnim((desksId) => [...desksId, desk._id])
                                    } else {
                                        let filteredDesksIds = desksIdsForAnim.filter(id => id !== desk._id)
                                        setDesksIdsForAnim(filteredDesksIds)
                                    }
                                }}>
                                    {index === 0 && <div style={{ height: deskHeight * separatorRatio }}>
                                        <img alt={"img"} src={separator} height={deskHeight} style={{
                                            transform: `rotate(-90deg) translate(0px, ${- deskHeight * separatorRatio}px)`,
                                            transformOrigin: "top right"
                                        }}
                                        />
                                    </div>}
                                    <img src={DeskVImage} width={deskHeight} />
                                    <div style={{ height: deskHeight * separatorRatio }}>
                                        <img alt={"img"} src={separator} height={deskHeight} style={{
                                            transform: `rotate(-90deg) translate(0px, ${- deskHeight * separatorRatio}px)`,
                                            transformOrigin: "top right"
                                        }}
                                        />
                                    </div>
                                    <span style={{ position: "absolute", fontSize: deskHeight / 5, right: deskHeight / 1.4, pointerEvents: "none" }}>
                                        {deskState &&
                                            <FontAwesomeIcon style={{ color: "#33FFC8" }} icon={byPrefixAndName.fas['power-off']} />
                                        }
                                        {!deskState && !desksIdsForAnim.find(id => id === desk._id) &&
                                            <FontAwesomeIcon style={{ color: "#000000" }} icon={byPrefixAndName.fas['power-off']} />
                                        }
                                        {!deskState && desksIdsForAnim.find(id => id === desk._id) && <Lottie
                                            loop={true}
                                            play={true}
                                            animationData={startAnimation}
                                            style={{ width: deskHeight / 3, height: deskHeight / 3, left: 25, top: -2, position: "relative" }}
                                        />}
                                    </span>
                                    {devicesToStart.includes(desk.deviceId) && <span className={styles.loader} style={{ position: 'absolute', fontSize: 70, right: 30, color: "white" }}></span>}

                                </div>
                                )

                            })}
                        </div>
                    </div>
                    <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {room?.desks_east.map((desk, index) => {
                                let deskState = onlineDevices.find(
                                    (deviceId) => deviceId === desk.deviceId
                                );

                                return (<div key={desk.number} style={{ position: "relative", display: "flex", flexDirection: "column", justifyContent: "center" }} onClick={() => {
                                    onDeskClicked(desk.deviceId, deskState)
                                    if (!deskState) {
                                        if (!desksIdsForAnim.find(id => id === desk._id))
                                            setDesksIdsForAnim((desksId) => [...desksId, desk._id])
                                    } else {
                                        let filteredDesksIds = desksIdsForAnim.filter(id => id !== desk._id)
                                        setDesksIdsForAnim(filteredDesksIds)
                                    }
                                }}>
                                    {index === 0 && <div style={{ height: deskHeight * separatorRatio }}>
                                        <img alt={"img"} src={separator} height={deskHeight} style={{
                                            transform: `rotate(90deg) translate(0px, ${- deskHeight}px)`,
                                            transformOrigin: "top left"
                                        }}
                                        />
                                    </div>}
                                    <img src={DeskVImage} width={deskHeight} style={{ transform: "rotate(180deg)" }} />
                                    <div style={{ height: deskHeight * separatorRatio }}>
                                        <img alt={"img"} src={separator} height={deskHeight} style={{
                                            transform: `rotate(90deg) translate(0px, ${- deskHeight}px)`,
                                            transformOrigin: "top left"
                                        }}
                                        />
                                    </div>
                                    <span style={{ position: "absolute", fontSize: deskHeight / 5, left: deskHeight / 1.4, pointerEvents: "none" }}>
                                        {deskState &&
                                            <FontAwesomeIcon style={{ color: "#33FFC8" }} icon={byPrefixAndName.fas['power-off']} />
                                        }
                                        {!deskState && !desksIdsForAnim.find(id => id === desk._id) &&
                                            <FontAwesomeIcon style={{ color: "#000000" }} icon={byPrefixAndName.fas['power-off']} />
                                        }
                                        {!deskState && desksIdsForAnim.find(id => id === desk._id) && <Lottie
                                            loop={true}
                                            play={true}
                                            animationData={startAnimation}
                                            style={{ width: deskHeight / 3, height: deskHeight / 3, right: 20, top: -2, position: "relative" }}
                                        />}
                                    </span>
                                    {devicesToStart.includes(desk.deviceId) && <span className={styles.loader} style={{ position: 'absolute', fontSize: 70, left: 30, color: "white" }}></span>}
                                </div>)
                            }


                            )}
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    {
                        room?.desks_south.length > 0 && room?.desks_west.length > 0 && <>
                            <img src={CornerImage} height={deskHeight} style={{ transform: "rotate(-90deg)" }} />
                            <img alt={"img"} src={separator} height={deskHeight} style={{ position: "relative", transform: "rotate(180deg)" }} />
                        </>
                    }
                    {room?.desks_south.map((desk) => {
                        let deskState = onlineDevices.find(
                            (deviceId) => deviceId === desk.deviceId
                        );

                        return (<div key={desk.number} style={{ position: "relative", display: "flex", justifyContent: "center" }} onClick={() => {
                            onDeskClicked(desk.deviceId, deskState, deskData._id === desk?._id)
                            if (!deskState) {
                                if (!desksIdsForAnim.find(id => id === desk._id))
                                    setDesksIdsForAnim((desksId) => [...desksId, desk._id])
                            } else {
                                let filteredDesksIds = desksIdsForAnim.filter(id => id !== desk._id)
                                setDesksIdsForAnim(filteredDesksIds)
                            }
                        }}>
                            <img src={DeskHImage} height={deskHeight} style={{ transform: "rotate(180deg)" }} />
                            <img alt={"img"} src={separator} height={deskHeight} style={{ position: "relative", transform: "rotate(180deg)" }} />
                            {deskData._id === desk?._id && <span style={{ position: "absolute", color: "#33FFC8", fontSize: deskHeight / 5, top: deskHeight / 6, pointerEvents: "none" }}>
                                <FontAwesomeIcon icon={byPrefixAndName.fas['microphone-stand']} />
                            </span>}
                            <span style={{ position: "absolute", fontSize: deskHeight / 5, top: deskHeight / 1.55, pointerEvents: "none" }}>
                                {deskState &&
                                    <FontAwesomeIcon style={{ color: "#33FFC8" }} icon={byPrefixAndName.fas['power-off']} />
                                }
                                {!deskState && !desksIdsForAnim.find(id => id === desk._id) &&
                                    <FontAwesomeIcon style={{ color: "#000000" }} icon={byPrefixAndName.fas['power-off']} />
                                }
                                {!deskState && desksIdsForAnim.find(id => id === desk._id) && <Lottie
                                    loop={true}
                                    play={true}
                                    animationData={startAnimation}
                                    style={{ width: deskHeight / 3, height: deskHeight / 3, top: -10, position: "relative" }}
                                />}
                            </span>
                            {devicesToStart.includes(desk.deviceId) && <span className={styles.loader} style={{ position: 'absolute', fontSize: 70, top: 30, color: "white" }}></span>}
                        </div>)
                    })}
                    {
                        room?.desks_south.length > 0 && room?.desks_east.length > 0 && <img src={CornerImage} height={deskHeight} style={{ transform: "rotate(180deg)" }} />
                    }
                </div>
            </div>
            <DarkButtonComponent style={{ width: 353, marginBottom: 30 }} onClick={() => setOpenStationsMap(false)}>
                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['xmark']} />Back
            </DarkButtonComponent>
        </div>

    );
}

export default StationMapComponent;
